import React, { FunctionComponent } from 'react';
import { SanityTable } from '../../../types/common';
import './styles.scss';

type TableProps = {
  data: SanityTable;
}

const Table: FunctionComponent<TableProps> = ({ data }) => {
  return (
    <table className='table' border={1}>
      <tbody>
        {data.rows.map(row => (
          <tr key={row._key}>
            {row.cells.map(cell => (
              <td key={row._key + cell}>{cell}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default Table;
